import EventsTable from './EventsTable'

export default EventsTable
